import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "reached-limit-actions-header"
}

import { computed, onMounted, ref, watch } from 'vue';
import { useBillingStore } from '@/stores/billing';
import VIconButton from './VIconButton.vue';
import CloseIcon from './icons/navigation/CloseIcon.vue';
import BillingInfoDialog from './dialogs/BillingInfoDialog.vue';
import { useDialogStore } from '@/stores/dialogs';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReachedLimitActionsHeader',
  setup(__props) {

const show = ref(true)
const billingStore = useBillingStore()

const reachedLimit = computed(() => {
  if (!billingStore.details) return false
  if (billingStore.details.is_subscriber) return false
  if (billingStore.details.free_actions >= billingStore.details.max_free_actions || billingStore.details.paid_actions > 0) return true
  // if (billingStore.details.paid_actions > 0 || billingStore.details.max_free_actions === 0 || billingStore.details.free_actions < billingStore.details.max_free_actions) return false

  return false
})

onMounted(() => {
  if (window.localStorage.getItem("showLimitAlert") === "show") {
    show.value = true
  }
})
watch(() => billingStore.details, () => {
  if (!billingStore.details) return
  if (billingStore.details.free_actions >= billingStore.details.max_free_actions || billingStore.details.paid_actions > 0) {
    window.localStorage.setItem("showLimitAlert", "show")
  }
}, { immediate: true })

const dialogStore = useDialogStore()
const connectCreditCard = () => {
  dialogStore.open(BillingInfoDialog, { startPage: "details" })
}

const close = () => {
  show.value = false
  window.localStorage.setItem("showLimitAlert", "hide")
}


return (_ctx: any,_cache: any) => {
  return (_unref(reachedLimit) && show.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(" You have reached the limit of free actions! Please "),
        _createElementVNode("a", { onClick: connectCreditCard }, "connect your credit card"),
        _createTextVNode(" to continue. "),
        _createVNode(VIconButton, { onClick: close }, {
          default: _withCtx(() => [
            _createVNode(CloseIcon)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})